<template>
  <div class="m-5 p-5 pt-0" style="text-align: left !important">
    <div class="row">
      <div class="col-12 text-center mt-2">
        <label class="title">Create Collection Application</label>
      </div>
      <div class="text-right">
        <button class="btn btn-secondary" type="button" @click="reloadPage">Reset</button>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-12">
          <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Application Type</label>
        </div>
        <div class="col-6">
          <div class="mb-3 form-check">
            <input class="form-check-input" type="radio" name="applicationType" id="offlineCollection" v-model="applicationType" value="offline" :disabled="selectedService != null" />
            <label class="form-check-label" for="offlineCollection">Offline Application</label>
          </div>
        </div>
        <!-- <div class="col-6">
          <div class="mb-3 form-check">
            <input type="radio" name="applicationType" class="form-check-input" id="onlineollection" v-model="applicationType" value="online" :disabled="selectedService != null"/>
            <label class="form-check-label" for="onlineollection">Online Application</label>
          </div>
        </div> -->
      </div>
     <div v-if="applicationType == 'offline'" class="row">
      <div class="col-12">
        <label class="subTitle mb-3" style="font-size: 20px;">Settlement</label>
      </div>
      <div class="col-6">
        <div class="mb-3 form-check">
          <input class="form-check-input" type="radio" name="applicationSettlement" id="appSettlement" v-model="applicationSettlement" value="Whish App" />
          <label class="form-check-label" for="appSettlement">Whish App</label>
        </div>
      </div>
      <div class="col-6">
        <div class="mb-3 form-check">
          <input type="radio" name="applicationSettlement" class="form-check-input" id="moneySettlement" v-model="applicationSettlement" value="Whish Money" />
          <label class="form-check-label" for="moneySettlement">Whish Money</label>
        </div>
      </div>
     </div> 
      <div v-if="applicationType == 'online' || (applicationType == 'offline' && applicationSettlement)">
        <div class="row">
          <div class="col-12">
            <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Set Service</label>
          </div>
          <div class="col-6">
            <div class="mb-3 form-check">
              <input class="form-check-input" type="radio" name="setService" id="existingService" v-model="newService" :value="false" />
              <label class="form-check-label" for="existingService">Existing Service</label>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3 form-check">
              <input type="radio" name="setService" class="form-check-input" id="newService" v-model="newService" :value="true" data-bs-toggle="modal" data-bs-target="#newServiceModal" />
              <label class="form-check-label" for="newService">New Service</label>
            </div>
          </div>
        </div>
        <div v-if="newService != null && !newService" class="row">
          <div class="col-4 d-inline-flex">
            <v-select :options="services" label="name" class="vselect w-100" placeholder="Choose Service" v-model="selectedService" :reduce="selectedService => selectedService.id" >
              <template slot="option" slot-scope="option" >
                  <span class="pl-4">{{ option.id + " - " + option.name }}</span>
              </template>
            </v-select>
            <button type="button" class="btn btn-secondary ms-1" @click="getServices('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div class="modal fade" id="newServiceModal" tabindex="-1" aria-labelledby="newServiceModal" aria-hidden="true">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <label class="modal-title subTitle">Create Service</label>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <label class="form-label">Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="service.name" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" ref="closeServiceModal" data-bs-dismiss="modal" @click="newService = false">Close</button>
                <button type="button" class="btn btn-primary"  @click="createService">Create Service</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedService">
        <div class="row mt-3">
          <div class="col-12">
            <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Set Denomination</label>
          </div>
        <div class="col-6">
          <div class="mb-3 form-check">
            <input class="form-check-input" type="radio" name="setDenomination" id="existingDenomination" v-model="newDenomination" :value="false" />
            <label class="form-check-label" for="existingDenomination">Existing Denomination</label>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3 form-check">
            <input type="radio" name="setDenomination" class="form-check-input" id="newDenomination" v-model="newDenomination" :value="true" data-bs-toggle="modal" data-bs-target="#newDenominationeModal" />
            <label class="form-check-label" for="newDenomination">New Denomination</label>
          </div>
        </div>
      </div>
    </div>
      <div v-if="newDenomination != null && !newDenomination">
        <div class="row">
          <div class="col-4 d-inline-flex">
            <v-select :options="denominations" label="name" class="vselect w-100" placeholder="Choose Denomination" v-model="denomination.id" :reduce="id => id.id" >
              <template slot="option" slot-scope="option" >
                  <span class="pl-4">{{ option.id + " - " + option.name }}</span>
              </template>
            </v-select>
            <button type="button" class="btn btn-secondary ms-1" @click="getDenominationBeans('selectedService', true)"><i class="bi bi-arrow-clockwise"></i></button>
          </div>
          <div class="col-4">
            <button type="button" class="btn btn-primary" @click="checkDenomination" :disabled="denomination.id == null">Confirm</button>
          </div>
        </div>
      </div>
      <div class="modal fade" id="newDenominationeModal" tabindex="-1" aria-labelledby="newDenominationeModal" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <label class="modal-title subTitle">Create Denomination</label>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Name <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="denomination.name" />
                    </div>
                  </div>
                  <div class="col-4" v-if="applicationType == 'online' || (applicationType == 'offline' && applicationSettlement == 'Whish Money')">
                    <div class="mb-3" v-if="applicationType == 'online'">
                      <label class="form-label">Web Server <span class="text-danger">*</span></label>
                      <div class=" d-inline-flex w-100">
                        <v-select :options="webServers" label="name" class="vselect w-100" placeholder="Choose Web Server" v-model="denomination.webServerId" :reduce="webServerId => webServerId.id" >
                          <template slot="option" slot-scope="option" >
                              <span class="pl-4">{{ option.name }}</span>
                          </template>
                        </v-select>
                        <button type="button" class="btn btn-secondary ms-1" @click="getWebServers('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                      </div>
                    </div>
                    <div class="mb-3" v-else>
                      <label class="form-label">Web Server <span class="text-danger">*</span></label>
                      <div class=" d-inline-flex w-100">
                        <v-select :options="filterOfflineWebServers(webServers)" label="name" class="vselect w-100" placeholder="Choose Web Server" v-model="denomination.webServerId" :reduce="webServerId => webServerId.id" >
                          <template slot="option" slot-scope="option" >
                              <span class="pl-4">{{ option.name }}</span>
                          </template>
                        </v-select>
                        <button type="button" class="btn btn-secondary ms-1" @click="getWebServers('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-4" v-if="(applicationType == 'offline' && applicationSettlement == 'Whish Money')">
                    <div class="mb-3">
                      <label class="form-label">Whish Money Service ID <span class="text-danger">*</span></label>
                      <input type="number" class="form-control" v-model="denomination.externalId" />
                    </div>
                  </div>
                  <div class="col-4" style="margin: auto 0;">
                    <div class="mb-3 form-check">
                      <input type="checkbox" class="form-check-input" id="autoAcceptTopup" v-model="denomination.autoAcceptTopup">
                      <label class="form-check-label" for="autoAcceptTopup"> Auto Accept Topup<span class="text-danger"> *</span></label>
                    </div>
                  </div>
                  <div class="col-4" style="margin: auto 0;">
                    <div class="mb-3 form-check">
                      <input type="checkbox" class="form-check-input" id="bulkMultiBillPayment" v-model="denomination.bulkMultiBillPayment">
                      <label class="form-check-label" for="bulkMultiBillPayment"> Bulk Multi Bill Payment<span class="text-danger"> *</span></label>
                    </div>
                  </div>
                  <!-- <div class="col-4" style="margin: auto 0;">
                    <div class="mb-3 form-check">
                      <input type="checkbox" class="form-check-input" id="topupWhishAccount" v-model="denomination.topupWhishAccount">
                      <label class="form-check-label" for="topupWhishAccount"> Topup Whish Account<span class="text-danger"> *</span></label>
                    </div>
                  </div> -->
                </div>
                <div class="row" v-if="(applicationType == 'offline' && applicationSettlement == 'Whish App')">
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Accountings <span class="text-danger">*</span></label>
                      <div class=" d-inline-flex w-100">
                        <v-select :options="accountings" label="name" class="vselect w-100" placeholder="Choose Accounting" v-model="denomination.accountingId" :reduce="accountingId => accountingId.id" >
                          <template slot="option" slot-scope="option" >
                              <span class="pl-4">{{ option.name }}</span>
                          </template>
                        </v-select>
                        <button type="button" class="btn btn-secondary ms-1" @click="getAccountings('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                        <button type="button" class="btn btn-secondary ms-1"  @click="accounting.add = true"><i class="bi bi-plus-circle"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-4" v-if="accounting.add">
                    <div class="mb-3">
                      <label class="form-label">Accounting <span class="text-danger">*</span></label>
                      <div class=" d-inline-flex w-100">
                        <input type="text" class="form-control" v-model="accounting.name" />
                        <button type="button" class="btn btn-secondary ms-1"  @click="createAccounting"><i class="bi bi-plus-circle"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="(applicationType == 'offline' && applicationSettlement == 'Whish App')">
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Comments <span class="text-danger">*</span></label>
                      <div class=" d-inline-flex w-100">
                        <v-select :options="comments" label="name" class="vselect w-100" placeholder="Choose Comment" v-model="denomination.commentId" :reduce="commentId => commentId.id" >
                          <template slot="option" slot-scope="option" >
                              <span class="pl-4">{{ option.name }}</span>
                          </template>
                        </v-select>
                        <button type="button" class="btn btn-secondary ms-1" @click="getComments('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                        <button type="button" class="btn btn-secondary ms-1"  @click="comment.add = true"><i class="bi bi-plus-circle"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-4" v-if="comment.add">
                    <div class="mb-3">
                      <label class="form-label">comment <span class="text-danger">*</span></label>
                      <div class="d-inline-flex w-100">
                        <input type="text" class="form-control" v-model="comment.name" />
                        <button type="button" class="btn btn-secondary ms-1"  @click="createComment"><i class="bi bi-plus-circle"></i></button>
                      </div>
                    </div>
                  </div>
                </div>
                <ImageChooser :documents="denominationDocuments" :imageInformation="denomination" :refreshDocuments="refreshDocuments" :isMenu="false"/>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" ref="closeDenominationModal" data-bs-dismiss="modal" @click="newDenomination = false">Close</button>
              <button type="button" class="btn btn-primary"  @click="createDenomination">Create Denomination</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="fakeItemFailed">
        <div class="row mt-3">
          <div class="col-12">
            <label class="subTitle mb-3">Create Fake Item</label>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label >Denomination ID <span class="text-danger">*</span></label>
              <input type="number" class="form-control" v-model="denomination.id" disabled />
            </div>
          </div>
          <div class="col-8" style="margin: auto 0">
              <button type="button" class="btn btn-primary" @click="createFakeItem">Create</button>
          </div>
        </div>
      </div>
      <div v-if="(applicationType == 'online' && showProviderMapping) || (applicationType == 'offline' && applicationSettlement == 'Whish Money' && showProviderMapping)">
        <div class="row mt-3">
          <div class="col-12">
            <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Provider</label>
          </div>
          <div class="col-6">
            <div class="mb-3 form-check">
              <input type="radio" name="setProviderMapping" class="form-check-input" id="whishMoneyProvider" :value="true" data-bs-toggle="modal" data-bs-target="#newProviderMappingModal" />
              <label class="form-check-label" for="whishMoneyProvider">Whish Money</label>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3 form-check">
              <input type="radio" name="setProviderMapping" class="form-check-input" id="newProviderMapping" v-model="newProviderMapping" :value="false" />
              <label class="form-check-label" for="newProviderMapping">No Provider</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="newProviderMappingModal" tabindex="-1" aria-labelledby="newProviderMappingModal" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <label class="modal-title subTitle">New Provider Mapping</label>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Whish Money Service ID <span class="text-danger">*</span></label>
                      <input type="number" class="form-control" v-model="denomination.externalId" />
                    </div>
                  </div>
                  <div class="col-4" v-if="applicationType == 'online'">
                    <div class="mb-3">
                      <label class="form-label">Bill Type <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="providerBillType" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" ref="closeMappingModal" data-bs-dismiss="modal" @click="newProviderMapping = true">Close</button>
              <button type="button" class="btn btn-primary"  @click="createNewProviderMapping">Create Provider Mapping</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showChangeCommentAndAccounting">
        <div class="row mt-3">
          <div class="col-6">
            <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Change Comment And Accounting</label>
          </div>
          <div class="col-6 text-right">
            <button type="button" class="btn btn-primary" @click="changeCommentAndAccounting" :disabled="denomination.accountingId == null || denomination.commentId == null">Confirm</button>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label class="form-label">Accountings <span class="text-danger">*</span></label>
              <div class=" d-inline-flex w-100">
                <v-select :options="accountings" label="name" class="vselect w-100" placeholder="Choose Accounting" v-model="denomination.accountingId" :reduce="accountingId => accountingId.id" >
                  <template slot="option" slot-scope="option" >
                      <span class="pl-4">{{ option.name }}</span>
                  </template>
                </v-select>
                <button type="button" class="btn btn-secondary ms-1" @click="getAccountings('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                <button type="button" class="btn btn-secondary ms-1"  @click="accounting.add = true"><i class="bi bi-plus-circle"></i></button>
              </div>
            </div>
          </div>
          <div class="col-4" v-if="accounting.add">
            <div class="mb-3">
              <label class="form-label">Accounting <span class="text-danger">*</span></label>
              <div class=" d-inline-flex w-100">
                <input type="text" class="form-control" v-model="accounting.name" />
                <button type="button" class="btn btn-secondary ms-1"  @click="createAccounting"><i class="bi bi-plus-circle"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label class="form-label">Comments <span class="text-danger">*</span></label>
              <div class=" d-inline-flex w-100">
                <v-select :options="comments" label="name" class="vselect w-100" placeholder="Choose Comment" v-model="denomination.commentId" :reduce="commentId => commentId.id" >
                  <template slot="option" slot-scope="option" >
                      <span class="pl-4">{{ option.name }}</span>
                  </template>
                </v-select>
                <button type="button" class="btn btn-secondary ms-1" @click="getComments('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                <button type="button" class="btn btn-secondary ms-1"  @click="comment.add = true"><i class="bi bi-plus-circle"></i></button>
              </div>
            </div>
          </div>
          <div class="col-4" v-if="comment.add">
            <div class="mb-3">
              <label class="form-label">comment <span class="text-danger">*</span></label>
              <div class="d-inline-flex w-100">
                <input type="text" class="form-control" v-model="comment.name" />
                <button type="button" class="btn btn-secondary ms-1"  @click="createComment"><i class="bi bi-plus-circle"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showCreateSchemaPrice">
        <div class="row mt-3">
          <div class="col-12">
            <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Set Schema Price</label>
          </div>
          <div class="col-6">
            <div class="mb-3 form-check">
              <input class="form-check-input" type="radio" name="setSchemaPrices" id="showCreateSchema" v-model="showCreateSchema" :value="true" data-bs-toggle="modal" data-bs-target="#schemaPriceModal" />
              <label class="form-check-label" for="showCreateSchema">Create Schema Price</label>
            </div>
          </div>
        </div>
      </div>
      <div  v-if="showExistingSchema">
        <div class="row" >
          <div class="col-12">
            <label class="subTitle" style="font-size: 20px">Available Schemas:</label>
            <table style="border-collapse: collapse;">
              <tr>
                <th>Amount From</th>
                <th>Amount To</th>
                <th>Discount</th>
                <th>Sale Price</th>
                <th>Price Type</th>
                <th>Currency</th>
              </tr>
              <tr v-for="(existingSchema, index) in existingSchemas" :key="index">
                <td>{{existingSchema.amountFrom}}</td>
                <td>{{existingSchema.amountTo}}</td>
                <td>{{existingSchema.discount}}</td>
                <td>{{existingSchema.salePrice}}</td>
                <td>{{(priceTypes.filter(f => f.id == existingSchema.priceType)).map(m => m.name)[0]}}</td>
                <td>{{(currencies.filter(f => f.currencyId == existingSchema.currencyId)).map(m => m.name)[0]}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-if="schemaPriceList != null && schemaPriceList.length > 0">
        <div class="row" >
          <div class="col-12">
            <label class="subTitle" style="font-size: 20px">Created Schemas:</label>
            <table style="border-collapse: collapse;">
              <tr>
                <th>Amount From</th>
                <th>Amount To</th>
                <th>Discount</th>
                <th>Sale Price</th>
                <th>Price Type</th>
                <th>Currency</th>
              </tr>
              <tr v-for="(price, index) in schemaPriceList" :key="index">
                <td>{{price.amountFrom}}</td>
                <td>{{price.amountTo}}</td>
                <td>{{price.discount}}</td>
                <td>{{price.salePrice}}</td>
                <td>{{(priceTypes.filter(f => f.id == price.priceType)).map(m => m.name)[0]}}</td>
                <td>{{(currencies.filter(f => f.currencyId == price.currencyId)).map(m => m.name)[0]}}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="modal fade" id="schemaPriceModal" tabindex="-1" aria-labelledby="schemaPriceModal" aria-hidden="true">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <label class="modal-title subTitle">Schema Price</label>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container-fluid">
                <div v-if="schemaPriceList != null && schemaPriceList.length > 0">
                  <div class="row" >
                    <div class="col-12">
                      <label class="subTitle" style="font-size: 20px">Available Schemas:</label>
                      <table style="border-collapse: collapse;">
                        <tr>
                          <th>Amount From</th>
                          <th>Amount To</th>
                          <th>Discount</th>
                          <th>Sale Price</th>
                          <th>Price Type</th>
                          <th>Currency</th>
                          <th>Action</th>
                        </tr>
                        <tr v-for="(price) in schemaPriceList" :key="price.id">
                          <td>{{price.amountFrom}}</td>
                          <td>{{price.amountTo}}</td>
                          <td>{{price.discount}}</td>
                          <td>{{price.salePrice}}</td>
                          <td>{{(priceTypes.filter(f => f.id == price.priceType)).map(m => m.name)[0]}}</td>
                          <td>{{(currencies.filter(f => f.currencyId == price.currencyId)).map(m => m.name)[0]}}</td>
                          <td>
                            <button type="button" class="btn btn-primary" @click="addSchemaPrice(price)">Edit</button>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Pricing Type <span class="text-danger">*</span></label>
                      <select class="form-select" aria-label="Choose Type" v-model="fixedSchemaPrice">
                        <option selected disabled :value="null">Choose Type</option>
                        <option :value="false">Brackets</option>
                        <option :value="true">Fixed Price</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-4" v-if="fixedSchemaPrice != null && !fixedSchemaPrice">
                    <div class="mb-3">
                      <label class="form-label">Amount From: <span class="text-danger">*</span></label>
                      <input type="number" class="form-control" v-model="schemaPrice.amountFrom" />
                    </div>
                  </div>
                  <div class="col-4" v-if="fixedSchemaPrice != null && !fixedSchemaPrice">
                    <div class="mb-3">
                      <label class="form-label">Amount To: <span class="text-danger">*</span></label>
                      <input type="number" class="form-control" v-model="schemaPrice.amountTo" />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Price Type <span class="text-danger">*</span></label>
                      <div class="d-inline-flex w-100">
                        <v-select :options="priceTypes == null ? [] : priceTypes" label="name" class="vselect w-100" placeholder="Choose Price Type" v-model="schemaPrice.priceType" :reduce="priceType => priceType.id" >
                          <template slot="option" slot-scope="option" >
                              <span class="pl-4">{{ option.name }}</span>
                          </template>
                        </v-select>
                        <button type="button" class="btn btn-secondary ms-1" @click="getPriceTypes('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Currency <span class="text-danger">*</span></label>
                      <select class="form-select" aria-label="Choose Service" v-model="schemaPrice.currencyId" disabled>
                        <option selected disabled :value="null">Choose Currency</option>
                        <option v-for="currency in currencies" :value="currency.currencyId" :key="currency.currencyId" >{{currency.name}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Sale Price: <span class="text-danger">*</span></label>
                      <input type="number" class="form-control" v-model="schemaPrice.salePrice" />
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Discount: <span class="text-danger">*</span></label>
                      <input type="number" class="form-control" v-model="schemaPrice.discount" />
                    </div>
                  </div>
                  <div class="col-12 text-end" v-if="fixedSchemaPrice != null && !fixedSchemaPrice">
                    <button type="button" class="btn btn-secondary"  @click="addSchemaPrice(null)"><i class="bi bi-plus-circle"></i></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" ref="closeSchemaPriceModal" data-bs-dismiss="modal" @click="showCreateSchema = true">Close</button>
              <button type="button" class="btn btn-primary"  @click="createSchemaPrice">Create Schema Price</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="showCreateApplication && applicationType == 'offline'" >
        <div class="row mt-3">
          <div class="col-12">
            <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Application And Application Fields</label>
          </div>
          <div class="col-6">
            <div class="mb-3 form-check">
              <input type="radio" :value="false" name="newApplication" class="form-check-input" id="oldApplication" v-model="newApplication" />
              <label class="form-check-label" for="oldApplication">Choose Existing Application</label>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3 form-check">
              <input type="radio" name="newApplication" class="form-check-input" id="newApplication" v-model="newApplication" :value="true" data-bs-toggle="modal" data-bs-target="#newApplicationModal" />
              <label class="form-check-label" for="newApplication">Create Application</label>
            </div>
          </div>
          <div v-if="newApplication != null && !newApplication">
            <div class="row">
              <div class="col-4">
                <div class="mb-3 d-inline-flex w-100">
                  <v-select :options="collectionApplications == null ? [] : collectionApplications" label="name" class="vselect w-100" placeholder="Choose Application" v-model="selectedApplication">
                    <template slot="option" slot-scope="option" >
                        <span class="pl-4">{{ option.name }}</span>
                    </template>
                  </v-select>
                  <button type="button" class="btn btn-secondary ms-1" @click="getCollectionApplications('created', true)"><i class="bi bi-arrow-clockwise"></i></button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6" v-if="allowAddApplicationField">
            <div class="mb-3 form-check">
              <input type="radio" @click="editApplicationField = false" name="newApplicationField" class="form-check-input" id="newApplicationField" v-model="newApplicationField" :value="true" data-bs-toggle="modal" data-bs-target="#newApplicationFieldModal" />
              <label class="form-check-label" for="newApplicationField">Create Application Field</label>
            </div>
          </div>
        </div>
        <div class="modal fade" id="newApplicationModal" tabindex="-1" aria-labelledby="newApplicationModal" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <label class="modal-title subTitle">Create Application</label>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4">
                      <div class="mb-3">
                        <label class="form-label">Title <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="applicationTitle" />
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="mb-3">
                        <label class="form-label">Tags <span class="text-danger">*</span></label>
                        <vue-multi-select style="width: 100%; text-align: start" ref="multiSelect" v-model="applicationTags" search 
                        :options="options" :filters="filters" :btnLabel="btnLabel" :selectOptions="tags">
                      </vue-multi-select>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="mb-3">
                        <label class="form-label">Account ID <small class="text-danger">{{applicationAccount.name}}</small></label>
                        <input @blur="accountSearch" type="number" class="form-control" v-model="applicationAccount.id" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="subTitle">Automated Application Field Information</label>
                    </div>
                  </div>
                  <AppField v-model="fields['payerFirstName']" :field="fields['payerFirstName']" :stringFields="stringFields" :getStringFields="getStringFields"/>
                  <AppField v-model="fields['payerLastName']" :field="fields['payerLastName']" :stringFields="stringFields" :getStringFields="getStringFields"/>
                  <AppField v-model="fields['payerPhone']" :field="fields['payerPhone']" :stringFields="stringFields" :getStringFields="getStringFields"/>
                  <AppField v-model="fields['amount']" :field="fields['amount']" :stringFields="stringFields" :getStringFields="getStringFields"/>
                  <AppField v-model="fields['feesAmount']" :field="fields['feesAmount']" :stringFields="stringFields" :getStringFields="getStringFields"/>
                  <AppField v-model="fields['receivableAmount']" :field="fields['receivableAmount']" :stringFields="stringFields" :getStringFields="getStringFields"/>

                  <div class="col-4">
                    <div class="mb-3 form-check">
                      <input type="checkbox" class="form-check-input" id="applicationIsReference" v-model="applicationIsReference"/>
                      <label class="form-check-label" for="applicationIsReference">Payer Reference</label>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="applicationIsReference">
                  <AppField v-if="applicationIsReference" v-model="fields['payerReference']" :field="fields['payerReference']" :stringFields="stringFields"/>
                  <div class="col-12" >
                    <div class="mb-3">
                      <label class="subTitle" style="font-size: 20px;">Payer Reference Input Information</label>
                    </div>
                  </div>
                  <div class="col-12">
                    <FieldTypeData :applicationFieldTypes="applicationFieldTypes" :applicationFieldData="fields['payerReference'].fieldData" :applicationFields="applicationFields" :getApplicationFieldTypes="getApplicationFieldTypes" :getApplicationFieldsByApplicationId="getApplicationFieldsByApplicationId"/>
                  </div>
                </div>
                <div class="row" v-if="applicationSettlement == 'Whish Money'">
                  <AppField  v-model="fields['reasonId']" :field="fields['reasonId']" :stringFields="stringFields"/>
                  <div class="col-4">
                    <div class="mb-3">
                      <label class="form-label">Whish Money Reason ID <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="fields['reasonId'].fieldData.defaultValue" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" ref="closeApplicationModal" data-bs-dismiss="modal" @click="newApplication = false">Close</button>
                <button type="button" class="btn btn-primary"  @click="createApplication">Create Application</button>
              </div>
            </div>
          </div>
        </div>
        <div class="modal fade" id="newApplicationFieldModal" tabindex="-1" aria-labelledby="newApplicationFieldModal" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <label class="modal-title subTitle">{{editApplicationField ? "Edit " : "Create "}}Application Field</label>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">

                  <AppField v-model="applicationField" :field="applicationField" :stringFields="stringFields" :getStringFields="getStringFields"/>
                  <div class="row">
                    <div class="col-4">
                      <div class="mb-3">
                        <label class="form-label">Identifier <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="applicationField.identifier" />
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="mb-3">
                        <label class="form-label">Index <span class="text-danger">*</span></label>
                        <input type="number" class="form-control" v-model="applicationField.index" />
                      </div>
                    </div>
                  </div>
                  <FieldTypeData :applicationFieldTypes="applicationFieldTypes" :applicationFieldData="applicationField.fieldData" :applicationFields="applicationFields" :getApplicationFieldTypes="getApplicationFieldTypes" :getApplicationFieldsByApplicationId="getApplicationFieldsByApplicationId"/>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" ref="closeApplicationFieldModal" data-bs-dismiss="modal" @click="newApplicationField = false">Close</button>
                <button type="button" class="btn btn-primary"  @click="createApplicationField">{{ editApplicationField ? "Edit " : "Create " }} Application Field</button>
              </div>
            </div>
          </div>
        </div>
        <div v-if="applicationFields.length > 1" class="row">
          <div class="col-12">
            <label class="subTitle" style="font-size: 20px">Available Fields:</label>
            <table style="border-collapse: collapse;">
              <tr>
                <th>Title</th>
                <th>Type</th>
                <th>Identifier</th>
                <th>Index</th>
              </tr>
              <tr v-for="field in applicationFields" :key="field.id">
                <td>{{field.title}}</td>
                <td>{{field.type}}</td>
                <td>{{field.identifier}}</td>
                <td>{{field.index}}</td>
                <td>
                  <input type="radio" name="newApplicationField" class="form-check-input d-none" id="editApplicationField" v-model="newApplicationField" :value="true" data-bs-toggle="modal" data-bs-target="#newApplicationFieldModal"/>
                  <label class="btn btn-primary" for="editApplicationField" @click="updateApplicationField(field)">Edit</label>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div v-if="(showCreateMenuItem )" >
        <div class="row mt-3">
          <div class="col-12">
            <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Menu Item</label>
          </div>
          <div class="col-12">
            <div class="mb-3 form-check">
              <input type="radio" name="setMenuItem" class="form-check-input" id="newMenuItem" v-model="newMenuItem" :value="true" data-bs-toggle="modal" data-bs-target="#newMenuItemModal" />
              <label class="form-check-label" for="newMenuItem">Create New Menu Item</label>
            </div>
          </div>
        </div>
        <div class="modal fade" id="newMenuItemModal" tabindex="-1" aria-labelledby="newMenuItemModal" aria-hidden="true">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header">
                <label class="modal-title subTitle">Create Menu Item</label>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-4" v-if="applicationType == 'online'">
                      <div class="mb-3">
                        <label class="form-label">Menu Item Chooser Type<span class="text-danger">*</span></label>
                        <select class="form-select" aria-label="Choose Type" v-model="importedMenuItem">
                          <option :value="true">Existing Menu Item</option>
                          <option :value="false">New Menu Item</option>
                        </select>
                      </div>
                    </div>
                    <div v-if="applicationType == 'online' && importedMenuItem" class="col-4">
                      <div class="mb-3">
                        <label class="form-label">Menu Item <span class="text-danger">*</span></label>
                        <v-select :options="billMenuItems == null ? [] : billMenuItems" label="label" class="vselect w-100" placeholder="Choose Menu Item" v-model="selectedMenuItem">
                          <template slot="option" slot-scope="option" >
                              <span class="pl-4">{{ option.label }}</span>
                          </template>
                        </v-select>
                        <button type="button" class="btn btn-secondary ms-1" @click="getBillMenuItems"><i class="bi bi-arrow-clockwise"></i></button>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="mb-3">
                        <label class="form-label">Menu ID <span class="text-danger">*</span></label>
                        <select class="form-select" aria-label="Choose Type" v-model="menuItem.menuId" :disabled="importedMenuItem">
                          <option :value="null" disabled selected>Choose Menu ID</option>
                          <option :value="1">1</option>
                          <option :value="2">2</option>
                          <option :value="3">3</option>
                          <option :value="4">4</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="mb-3">
                        <label class="form-label">Type <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="menuItem.type" disabled/>
                      </div>
                    </div>
                    <div class="col-4" v-if="!menuItem.localize">
                      <div class="mb-3">
                        <label class="form-label">Label <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="menuItem.hintFromOldKey" :disabled="importedMenuItem" />
                      </div>
                    </div>
                    <div v-if="!importedMenuItem && menuItem.localize" class="col-12">
                      <AppField v-model="menuItem" :field="menuItem" :stringFields="stringFields" :getStringFields="getStringFields"/>
                    </div>
                    <div class="col-4" v-if="applicationType == 'offline'">
                      <div class="mb-3">
                        <label class="form-label">Application <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="applicationTitle" disabled />
                      </div>
                    </div>
                    <div class="col-4" style="margin: auto 0;">
                      <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="menuItemTintable" v-model="menuItem.tintable" :disabled="importedMenuItem">
                        <label class="form-check-label" for="menuItemTintable"> Tintable<span class="text-danger"> *</span></label>
                      </div>
                    </div>
                    <div class="col-4" style="margin: auto 0;">
                      <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="menuItemSearchable" v-model="menuItem.searchable" :disabled="importedMenuItem">
                        <label class="form-check-label" for="menuItemSearchable"> Searchable<span class="text-danger"> *</span></label>
                      </div>
                    </div>
                    <div class="col-4" style="margin: auto 0;">
                      <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="menuItemLocalize" v-model="menuItem.localize" :disabled="importedMenuItem">
                        <label class="form-check-label" for="menuItemLocalize"> Localize<span class="text-danger"> *</span></label>
                      </div>
                    </div>
                    <div class="col-4" style="margin: auto 0;">
                      <div class="mb-3 form-check">
                        <input type="checkbox" class="form-check-input" id="menuItemRequiresVerification" v-model="menuItem.requiresVerification" :disabled="importedMenuItem">
                        <label class="form-check-label" for="menuItemRequiresVerification"> Requires Verification<span class="text-danger"> *</span></label>
                      </div>
                    </div>
                  </div>
                  <div v-if="importedMenuItem" class="col-4">
                    <label class="form-label mb-0">Image Displayer</label>
                    <img  v-img:name :src="menuItem.imageUrl" style="width: 50px; height: 50px" />
                  </div>
                  <ImageChooser v-if="!importedMenuItem" :documents="menuItemDocuments" :imageInformation="menuItem" :refreshDocuments="refreshDocuments" :isMenu="true"/>
                  <div v-if="applicationType == 'online'">
                    <FieldTypeData :applicationFieldTypes="applicationFieldInputTypes" :applicationFieldData="menuItem.dataRequest" :getApplicationFieldTypes="getApplicationFieldTypes" :getApplicationFieldsByApplicationId="getApplicationFieldsByApplicationId"/>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" ref="closeMenuitemModal" data-bs-dismiss="modal" @click="newMenuItem = null">Close</button>
                <button type="button" class="btn btn-primary" @click="createMenuItem">Create Menu Item</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="createdMenuItem != null" class="row">
        <div class="col-12">
          <table>
            <tr>
              <th>Menu ID</th>
              <th>Type</th>
              <th>Title</th>
              <th>Tintable</th>
              <th>Searchable</th>
              <th>Localize</th>
              <th>Requires Verification</th>
              <th>Image</th>
            </tr>
            <tr>
              <td class="text-center">{{createdMenuItem.menuId}}</td>
              <td>{{createdMenuItem.type}}</td>
              <td>
                <span v-if="createdMenuItem.localize">
                  {{(stringFields.filter(f => f.title == createdMenuItem.label))[0].value}}
                </span>
                <span v-else>
                  {{ createdMenuItem.label }}
                </span>
              </td>
              <td class="text-center">
                <i v-if="createdMenuItem.tintable" class="bi bi-check2 text-success" style="font-size: 25px"></i>
                <i v-else class="bi bi-x" style="font-size: 30px"></i>
              </td>
              <td class="text-center">
                <i v-if="createdMenuItem.searchable" class="bi bi-check2 text-success" style="font-size: 25px"></i>
                <i v-else class="bi bi-x text-danger" style="font-size: 30px"></i>
              </td>
              <td class="text-center">
                <i v-if="createdMenuItem.localize" class="bi bi-check2 text-success" style="font-size: 25px"></i>
                <i v-else class="bi bi-x text-danger" style="font-size: 30px"></i>
              </td>
              <td class="text-center">
                <i v-if="createdMenuItem.requiresVerification" class="bi bi-check2 text-success" style="font-size: 25px"></i>
                <i v-else class="bi bi-x text-danger" style="font-size: 30px"></i>
              </td>
              <td><img  v-img:name :src="createdMenuItem.iconURL" style="width: 50px; height: 50px" /></td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="showCreateAdminUser">
        
        <div class="row mt-3">
          <div class="col-12">
            <label class="subTitle mb-3"><i class="bi bi-dash me-2"></i>Admin User</label>
          </div>
          <div class="row">
            <div class="col-6">
            <div class="mb-3 form-check">
              <input type="radio" name="setAdminUser" class="form-check-input" id="adminUser" v-model="newAdminUser" :value="false" data-bs-toggle="modal"  />
              <label class="form-check-label" for="adminUser">Choose Existing Admin User</label>
            </div>
          </div>
            <div class="col-6">
              <div class="mb-3 form-check">
              <input type="radio" name="setAdminUser" class="form-check-input" id="newAdminUser" v-model="newAdminUser" :value="true" data-bs-toggle="modal" data-bs-target="#newAdminUserModal" />
              <label class="form-check-label" for="newAdminUser">Create New Admin User</label>
            </div>
          </div>
          </div>
          <div v-if="newAdminUser != null && !newAdminUser">
        <div class="row">
          <div class="col-4 d-inline-flex">
            <v-select :options="getUsers()" label="name" class="vselect w-100" placeholder="Choose Admin User" v-model="adminUser.id" :reduce="id => id.id" >
              <template slot="option" slot-scope="option" >
                  <span class="pl-4">{{ option.username + " - " + option.name }}</span>
              </template>
            </v-select>
            <button type="button" class="btn btn-secondary ms-1" @click="getUsers('selectedService', true)"><i class="bi bi-arrow-clockwise"></i></button>
          </div>
          <div class="col-4">
            <button type="button" class="btn btn-primary" @click="checkUser" :disabled="adminUser.id == null">Confirm</button>
          </div>
        </div>
      </div>
        </div>
      </div>
      <div class="modal fade"  id="newAdminUserModal" tabindex="-1" aria-labelledby="newAdminUserModal" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
           
            <div class="modal-header">
              
              <label class="modal-title subTitle">Create Admin User</label>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-6">
                    <div class="mb-3">
                      <label class="form-label">Name <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="adminUser.name"/>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="mb-3">
                      <label class="form-label">Username <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="adminUser.userName"/>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="mb-3">
                      <label class="form-label">Password <span class="text-danger">*</span></label>
                      <input type="text" class="form-control" v-model="adminUser.password"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" ref="closeAdminUserModal" data-bs-dismiss="modal" @click="newAdminUser = null">Close</button>
              <button type="button" class="btn btn-primary" @click="createAdminUser">Create Admin User</button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="createdAdminUser != null" class="row" style="margin-top: 20px;">
        <div class="col-12">
          <table>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Username</th>
              <th>Password</th>
            </tr>
            <tr>
              <td>{{createdAdminUser.id}}</td>
              <td>{{createdAdminUser.name}}</td>
              <td>{{createdAdminUser.userName}}</td>
              <td>{{adminUser.password}}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Http, { ENDPOINTS } from "../request";
import vueMultiSelect from 'vue-multi-select';
import 'vue-multi-select/dist/lib/vue-multi-select.css';
import FieldTypeData from "../components/FieldTypeData.vue";
import ImageChooser from '../components/ImageChooser.vue';
import AppField from '../components/ApplicationField.vue';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
  components: {
    vueMultiSelect,
    FieldTypeData,
    ImageChooser,
    AppField,
    vSelect,
  },
  data() {
    return {
      DOCUMENT_TYPE_MENU: 2,
      DOCUMENT_TYPE_DENOMINATION: 3,
      btnLabel: values => `Select (${values.length})`,
      filters: [{
        nameAll: 'Select all',
        nameNotAll: 'Deselect all',
        func() {
          return true;
        },
      }],
      options: {
        multi: true,
        groups: false,
        labelName: "label",
        labelValue: "id" ,
        cssSelected: option => (option.selected ? { 'color': '#E40046' } : ''),
      },
      applicationType: null,
      applicationSettlement: null,
      newService: null,
      services: null,
      selectedService: null,
      denominations: null,
      adminUsers:null,
      inputDenominationId: null,
      newDenomination: null,
      globalOperators: null,
      selectedDenominationOperator: null,
      denominationDocuments: null,
      menuItemDocuments: null,
      webServers: null,
      selectedDenominationWebServer: null,
      service:{
        id: null,
        name: null,
      },
      denomination: {
        id: null, 
        name: null,
        newImage: null,
        imageUrl: null,
        imageData: null,
        imageName: null,
        webServerId: null,
        settlement: null,
        autoAcceptTopup: true,
        bulkMultiBillPayment: false,
        commentId: null,
        accountingId: null,
        externalId:null
      },
      showChangeCommentAndAccounting: false,
      comment: {
        add: false,
        id: null,
        name: null,
      },
      accounting: {
        add: false,
        id: null,
        name: null,
      },
      comments: null,
      accountings: null,
      fakeItemFailed: false,    
      showCreateSchema: null,
      showCreateSchemaPrice: false,
      schemaPrice: {
        salePrice: null,
        amountFrom: null,
        amountTo: null,
        discount: null,
        priceType: null,
        currencyId: null
      },
      fixedSchemaPrice: null,
      showExistingSchema: false,
      existingSchemas: null,
      schemaPriceList: [],
      currencies: null,
      priceTypes: null,
      showProviderMapping: false,
      newProviderMapping: null,
      providers: null,
      providerBillType: null,
      showCreateApplication: false,
      stringFields: null,
      collectionApplications: null,
      selectedApplication: null,  
      newApplication: null,
      applicationTitle: null,
      applicationAccount : {
        id: null,
        name: null,
      },
      fields:{
        "payerFirstName":{
          "label":"Payer First Name",
          "newHint":false,
          "identifier":"payerfirstname",
          "hintFromOldKey":"field.cp.payer.first",
          "enHint":"",
          "arHint":"",
          "index":"1",
          "fieldData":{
            "type":"text",
          }
        },
        "payerLastName":{
          "label":"Payer Last Name",
          "newHint":false,
          "identifier":"payerlastname",
          "hintFromOldKey":"field.cp.payer.last",
          "enHint":"",
          "arHint":"",
          "index":"2",
          "fieldData":{
            "type":"text",
          }
        },
        "payerPhone":{
          "label":"Payer Phone",
          "newHint":false,
          "identifier":"payerPhone",
          "hintFromOldKey":"field.cp.payer.phone",
          "enHint":"",
          "arHint":"",
          "index":"3",
          "fieldData":{
            "type":"text",
          }
        },
        "amount":{
          "label":"Amount",
          "newHint":false,
          "identifier":"amount",
          "hintFromOldKey":this.$store.state.server.id == 1 ? "field.kva.amount.pay.lbp" : "field.collection.amount.pay.usd",
          "enHint":"",
          "arHint":"",
          "index":"4",
          "fieldData":{
            "type":"text",
          }
        },
        "feesAmount":{
          "label":"Fees Amount",
          "newHint":false,
          "identifier":"feesAmount",
          "hintFromOldKey":this.$store.state.server.id == 1 ? "field.collect.fees.lbp" : "field.collect.fees.usd",
          "enHint":"",
          "arHint":"",
          "index":"5",
          "fieldData":{
            "type":"equation",
          }
        },
        "receivableAmount":{
          "label":"Receivable Amount",
          "newHint":false,
          "identifier":"receivableamount",
          "hintFromOldKey":this.$store.state.server.id == 1 ? "field.lda.total_amount" : "field.lda.total_amount",
          "enHint":"",
          "arHint":"",
          "index":"6",
          "fieldData":{
            "type":"equation",
          }
        },
        "payerReference":{
          "label":"Payer Reference",
          "newHint":false,
          "identifier":"payerReference",
          "hintFromOldKey":null,
          "enHint":"",
          "arHint":"",
          "index":"7",
          "fieldData":{
              type:null,
              spinnerObject: null,
              applicationFieldTextValueString: null,
              spinnerPrompt: null,
              inputType: null,
              retrieveSavedContact: false,
              minNumber: null,
              maxNumber: null,
              applicationFieldMinCharacter: null,
              maxChar: null,
              wrongInputHint: null,
              radioSpanCount: null,
              hint: null,
              checkboxStylePopup: false,
              dateFormat: "dd-MM-yyyy",
            dependencies: [],
          }
        },
        "reasonId":{
          "label":"Reason Id",
          "newHint":false,
          "identifier":"reasonId",
          "hintFromOldKey":"field.reason.payment_type",
          "enHint":"",
          "arHint":"",
          "index":"8",
          "fieldData":{
            "defaultValue":null,
            "type":"hidden"
          }
        }
      },
      applicationIsReference: true,
      applicationTags: [],
      tags: [],
      applicationField: {
        id: null,
        label: "Application Field",
        newHint: false,
        identifier: null,
        hintFromOldKey: null,
        enHint: null,
        arHint: null,
        index: null,
        type: null,
        fieldData: {
          id: null,
          type: null,
          spinnerObject: null,
          applicationFieldTextValueString: null,
          spinnerPrompt: null,
          inputType: null,
          retrieveSavedContact: false,
          minNumber: null,
          maxNumber: null,
          minChar: null,
          maxChar: null,
          wrongInputHint: null,
          radioSpanCount: null,
          hint: null,
          checkboxStylePopup: false,
          dateFormat: "dd-MM-yyyy",
          dependencies: [],
        }
      },
      applicationFieldTypes: null,
      applicationFieldInputTypes: ["text", "phone", "numeric", "decimal"],
      applicationFieldIdentifiers: null,
      applicationFields: [],
      newApplicationField: null,
      editApplicationField: false,
      applicationFieldId: null,
      allowAddApplicationField: false,
      showCreateMenuItem: null,
      newMenuItem: null,
      menuItem: {
        label:"Menu Item",
        newHint: false, 
        enHint: null,
        arHint: null,
        hintFromOldKey: null,
        type: null,
        newImage: null,
        imageUrl: null,
        imageData: null,
        imageName: null,
        menuId: null,
        localize: false,
        tintable: false,
        requiresVerification: false,
        searchable: false,
        dataRequest: {
          id: null,
          type: null,
          spinnerObject: null,
          applicationFieldTextValueString: null,
          spinnerPrompt: null,
          inputType: null,
          retrieveSavedContact: false,
          minNumber: null,
          maxNumber: null,
          minChar: null,
          maxChar: null,
          wrongInputHint: null,
          radioSpanCount: null,
          hint: null,
          checkboxStylePopup: false,
          dateFormat: "dd-MM-yyyy",
          dependencies: [],
        },
      },
      billMenuItems: null,
      selectedMenuItem: null,
      importedMenuItem: false,
      showCreateAdminUser: false,
      newAdminUser: false,
      adminUser: {
        id:null,
        name: null,
        userName: null,
        password: null,
      },
      createdService: null,
      createdDenomination: null,
      createdSchemaPrice: null,
      createdProvider: null,
      createdApplication: null,
      createdApplicationField: null,
      createdMenuItem: null, 
      createdAdminUser: null,
    };
  },
  created(){
    this.schemaPrice.currencyId = this.$store.state.server.id == 1 ? 422 : this.$store.state.server.id == 2 ? 784 : 840;
    this.getServices("created");
    // this.getGlobalOperatorsBeans("created");
    this.getDenominationDocumnets("created");
    this.getMenuDocumnets("created");
    this.getWebServers("created");
    this.getStringFields("created");
    this.getTags("created");
    this.getApplicationFieldTypes("created");
    this.getApplicationFieldIdentifiers("created");
    // this.getProviders();
    this.getPriceTypes("created");
    this.getCurrencies("created");
    this.getCollectionApplications("created");
    this.getBillMenuItems();
    this.getComments("created");
    this.getAccountings("created");
    this.getUsers("created");
  },
  watch: {
    selectedService(){
      this.getDenominationBeans("selectedService",true);
    },
    newProviderMapping(){
      if(!this.newProviderMapping){
        this.showCreateSchemaPrice = true 
      }
    },
    createdApplication: {
      deep: true,
      handler() {
        this.getApplicationFieldsByApplicationId();
        this.applicationTitle = this.createdApplication.title
      }
    },
    selectedApplication: {
      deep: true,
      handler() {
        this.getApplicationFieldsByApplicationId();
        this.allowAddApplicationField = true
        this.applicationTitle = this.selectedApplication.name
        this.showCreateMenuItem = true
      }
    },
    applicationFieldData: {
      deep: true,
      handler() {
        if (this.applicationFieldData.type != "text") {
          this.applicationFieldData.inputType = null
        }
      }
    },
    payerReferenceData: {
      deep: true,
      handler() {
        if (this.fields['payerReference'].fieldData.type != "text") {
          this.fields['payerReference'].fieldData.inputType = null
        }
      }
    },
    applicationType(){
      if(this.applicationType == "online"){
        this.menuItem.type = "bill"
      } else if(this.applicationType == "offline"){
        this.menuItem.type = "dynamicapp"
      }
    },
    selectedMenuItem: {
      deep: true,
      handler() {
        this.menuItem.hintFromOldKey = this.selectedMenuItem.label
        this.selectedService = this.selectedMenuItem.serviceId
        this.menuItem.menuId = this.selectedMenuItem.menuId
        this.menuItem.imageUrl = this.selectedMenuItem.iconURL
        this.newMenuItemIcon = false
        this.menuItem.imageName = this.selectedMenuItem.icon
        this.menuItem.searchable = this.selectedMenuItem.searchable
        this.menuItem.localize = this.selectedMenuItem.localize
        this.menuItem.requiresVerification = this.selectedMenuItem.requiresVerification
        this.menuItem.localize = this.selectedMenuItem.localize
      }
    },
    fixedSchemaPrice(){
      this.schemaPriceList = []
      this.schemaPrice.amountFrom = null
      this.schemaPrice.amountTo = null  
      this.schemaPrice.priceType = null
      this.schemaPrice.discount = null
      this.schemaPrice.salePrice = null
    },
    applicationIsReference(){
      if( this.applicationIsReference && this.fields["payerReference"] == null){
        this.fields["payerReference"] = {
          "label":"Payer Reference",
          "newHint":false,
          "identifier":"payerReference",
          "hintFromOldKey":null,
          "enHint":"",
          "arHint":"",
          "index":"7",
          "fieldData":{
              type:null,
              spinnerObject: null,
              applicationFieldTextValueString: null,
              spinnerPrompt: null,
              inputType: null,
              retrieveSavedContact: false,
              minNumber: null,
              maxNumber: null,
              applicationFieldMinCharacter: null,
              maxChar: null,
              wrongInputHint: null,
              radioSpanCount: null,
              hint: null,
              checkboxStylePopup: false,
              dateFormat: "dd-MM-yyyy",
            dependencies: [],
          }
        }
      }
    },
    editApplicationField(){
      if(!this.editApplicationField){
        this.applicationField = {
          id: null,
          label: "Application Field",
          newHint: false,
          identifier: null,
          hintFromOldKey: null,
          enHint: null,
          arHint: null,
          index: null,
          type: null,
          fieldData: {
            id: null,
            type: null,
            spinnerObject: null,
            applicationFieldTextValueString: null,
            spinnerPrompt: null,
            inputType: null,
            retrieveSavedContact: false,
            minNumber: null,
            maxNumber: null,
            minChar: null,
            maxChar: null,
            wrongInputHint: null,
            radioSpanCount: null,
            hint: null,
            checkboxStylePopup: false,
            dateFormat: "dd-MM-yyyy",
            dependencies: [],
          }
        }
      }
    }
  },
  methods:{
    getServices(source,forceGet){
      if(source=='created' && (forceGet || this.services==null || this.services.length==0)){
        Http()
        .get(ENDPOINTS.servicesBeans, {
        })
        .then((response) => {
          if (response.status) {
            this.services = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getServices(source,true),500);
        });
      }
      return this.services;
    },
    getDenominationBeans(source,forceGet){
      if(source=='selectedService' && (forceGet || this.denominations==null || this.denominations.length==0)){
        Http()
        .post(ENDPOINTS.denominationBeans, {
          serviceId: this.selectedService,
          includeInactive: true,
        })
        .then((response) => {
          if (response.status) {
            this.denominations = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getDenominationBeans(source,true),500);
        });
      }
      return this.denominations;
    },getUsers(source,forceGet){
      if((forceGet || this.adminUsers==null || this.adminUsers.length==0)){
        Http()
        .get(ENDPOINTS.adminUserList, {
        })
        .then((response) => {
          
          if (response.status) {
            this.adminUsers = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getUsers(source,true),500);
        });
      }
      return this.adminUsers;
    },
    getGlobalOperatorsBeans(source,forceGet){
      if(source=='created' && (forceGet || this.globalOperators==null || this.globalOperators.length==0)){
      Http()
        .get(ENDPOINTS.globalOperatorsBeans, {
        })
        .then((response) => {
          if (response.status) {
            this.globalOperators = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getGlobalOperatorsBeans(source,true),500);
        });
      }
      return this.globalOperators;
    },
    getDenominationDocumnets(source,forceGet){
      if(source=='created' && (forceGet || this.denominationDocuments==null || this.denominationDocuments.length==0)){
        Http()
        .post(ENDPOINTS.documents, {
          type: this.DOCUMENT_TYPE_DENOMINATION
        })
        .then((response) => {
          if (response.status) {
            this.denominationDocuments = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getDenominationDocumnets(source,true),500);
        });
      }
      return this.denominationDocuments;
    },
    getMenuDocumnets(source,forceGet) {
      if(source=='created' && (forceGet || this.menuItemDocuments==null || this.menuItemDocuments.length==0)){
        Http()
        .post(ENDPOINTS.documents, {
          type: this.DOCUMENT_TYPE_MENU
        })
        .then((response) => {
          if (response.status) {
            this.menuItemDocuments = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getMenuDocumnets(source,true),500);
        });
      }
      return this.menuItemDocuments;
    },
    getWebServers(source,forceGet) {
      if(source=='created' && (forceGet || this.webServers==null || this.webServers.length==0)){
        Http()
        .get(ENDPOINTS.webServers, {
        })
        .then((response) => {
          if (response.status) {
            this.webServers = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getWebServers(source,true),500);
        });
      }
      return this.webServers;
    },
    filterOfflineWebServers(webServers){
      return webServers.filter(f => f.name.toLowerCase().includes("woo", "whish money"))
    },
    getStringFields(source,forceGet) {
      if(source=='created' && (forceGet || this.stringFields==null || this.stringFields.length==0)){
        Http()
        .get(ENDPOINTS.stringFields, {
        })
        .then((response) => {
          if (response.status) {
            this.stringFields = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getStringFields(source,true),500);
        });
      }
      return this.stringFields;
     
    },
    getTags(source,forceGet) {
      if(source=='created' && (forceGet || this.tags==null || this.tags.length==0)){
        Http()
        .get(ENDPOINTS.tags, {
        })
        .then((response) => {
          if (response.status) {
            this.tags = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getTags(source,true),500);
        });
      }
      return this.tags;
    },
    getApplicationFieldTypes(source,forceGet) {
      if(source=='created' && (forceGet || this.applicationFieldTypes==null || this.applicationFieldTypes.length==0)){
          Http()
        .get(ENDPOINTS.applicationFieldTypes, {
        })
        .then((response) => {
          if (response.status) {
            this.applicationFieldTypes = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getApplicationFieldTypes(source,true),500);
        });
      }
     
    },
    getApplicationFieldIdentifiers(source,forceGet) {
      if(source=='created' && (forceGet || this.applicationFieldIdentifiers==null || this.applicationFieldIdentifiers.length==0)){
        Http()
        .get(ENDPOINTS.applicationFieldIdentifier, {
        })
        .then((response) => {
          if (response.status) {
            this.applicationFieldIdentifiers = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getApplicationFieldIdentifiers(source,true),500);
        });
      }
      return this.applicationFieldIdentifiers;
    },
    getProviders(source,forceGet){
      if(source=='created' && (forceGet || this.providers==null || this.providers.length==0)){
        Http()
        .get(ENDPOINTS.externalProvidersBeans, {
        })
        .then((response) => {
          if (response.status) {
            this.providers = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getProviders(source,true),500);
        });
      }
      return this.providers;
    },
    getPriceTypes(source,forceGet) {
      if(source=='created' && (forceGet || this.priceTypes==null || this.priceTypes.length==0)){
        Http()
        .get(ENDPOINTS.priceTypes, {
        })
        .then((response) => {
          if (response.status) {
            this.priceTypes = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getPriceTypes(source,true),500);
        });
      }
      return this.priceTypes;
    },
    getCurrencies(source,forceGet) {
      if(source=='created' && (forceGet || this.currencies==null || this.currencies.length==0)){
        Http()
        .get(ENDPOINTS.currencies, {
        })
        .then((response) => {
          if (response.status) {
            this.currencies = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getCurrencies(source,true),500);
        });
      }
      
    },
    getApplicationFieldsByApplicationId() {
      if (this.createdApplication != null || this.selectedApplication != null) {
        Http()
          .post(ENDPOINTS.applicationFieldsById, {
            applicationId: this.createdApplication == null ? this.selectedApplication.id : this.createdApplication.id
          })
          .then((response) => {
            if (response.status) {
              this.applicationFields = response.data.sort((a, b) => a.index - b.index);
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.success(response.dialog.message)
              }
            } else {
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.error(response.dialog.message)
              }
            }
          })
          .catch((error) => {
            this.$toast.error("Internal Server Error!")
          })
      }
    },
    getSchemaPrices() {
      Http()
        .post(ENDPOINTS.schemaPrices, {
          denominationId: this.denomination.id
        })
        .then((response) => {
          if (response.status) {
            if(response.data.length > 0){
              this.existingSchemas = response.data;
              this.showExistingSchema = true
              if (this.applicationType == "offline"){
                this.showCreateApplication = true
              } else if (this.applicationType == "online"){
                this.showCreateMenuItem = true
              }
            } else {
              this.existingSchemas = []
              this.showExistingSchema = false
              this.showCreateSchemaPrice = true
            }
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    getCollectionApplications(source,forceGet) {
      if(source=='created' && (forceGet || this.collectionApplications==null ||this.collectionApplications.length==0)){
        Http()
        .get(ENDPOINTS.collectionApplications, {
        })
        .then((response) => {
          if (response.status) {
            this.collectionApplications = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getCollectionApplications(source,true),500);
        });
      }
      return this.collectionApplications;
    },
    getBillMenuItems(){
      Http()
        .get(ENDPOINTS.billMenuItems, {
        })
        .then((response) => {
          if (response.status) {
            this.billMenuItems = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    getAccountings(source,forceGet){
      if(source=='created' && (forceGet || this.accountings==null ||this.accountings.length==0)){
        Http()
        .get(ENDPOINTS.accountings, {
        })
        .then((response) => {
          if (response.status) {
            this.accountings = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getAccountings(source,true),500);
        });
      }
      return this.accountings;
    },
    getComments(source,forceGet){
      if(source=='created' && (forceGet || this.accountings==null ||this.accountings.length==0)){
        Http()
        .get(ENDPOINTS.comments, {
        })
        .then((response) => {
          if (response.status) {
            this.comments = response.data;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        }).catch((e)=>{
          setTimeout(this.getComments(source,true),500);
        });
      }
      return this.comments;
    },
    createService() {
      if (this.checkIfEmpty(this.service.name)) {
        this.$toast.error("Service Name is invalid")
        return;
      } 
      
      Http()
        .post(ENDPOINTS.createService, {
          ...this.service
        })
        .then((response) => {
          if (response.status) {
            this.service.id = response.data.serviceId
            this.services.push({
              "id":response.data.serviceId,
              "name":response.data.adminName
            });
            this.selectedService = response.data.serviceId
            this.newService = false
            this.createdService = response.data
            this.$refs.closeServiceModal.click()
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    createComment(){
      if(this.checkIfEmpty(this.comment.name)){
        this.$toast.error("Comment Is Invalid")
        return;
      }
      Http()
        .post(ENDPOINTS.createComment, {
          commentValue: this.comment.name
        })
        .then((response) => {
          if (response.status) {
            this.comments.push({
              id: response.data.id,
              name: response.data.name
            })
            this.denomination.commentId = response.data.id
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    createAccounting(){
      if(this.checkIfEmpty(this.accounting.name)){
        this.$toast.error("Accounting Is Invalid")
        return;
      }
      Http()
        .post(ENDPOINTS.createAccounting, {
          accountingValue: this.accounting.name
        })
        .then((response) => {
          if (response.status) {
            this.accountings.push({
              id: response.data.id,
              name: response.data.name
            })
            this.denomination.accountingId = response.data.id
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    changeCommentAndAccounting(){
      if(this.checkIfEmpty(this.denomination.commentId)){
        this.$toast.error("Comment Is Invalid")
        return;
      }
      if(this.checkIfEmpty(this.denomination.id)){
        this.$toast.error("Denomination Is Invalid")
        return;
      }
      if(this.checkIfEmpty(this.denomination.accountingId)){
        this.$toast.error("Accounting Is Invalid")
        return;
      }
      Http()
        .post(ENDPOINTS.changeCommentAndAccounting, {
          denominationId: this.denomination.id,
          commentId: this.denomination.commentId,
          accountingId: this.denomination.accountingId
        })
        .then((response) => {
          if (response.status) {
            this.getSchemaPrices();
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
            if(response.code == "already.set"){
              this.getSchemaPrices();
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    createDenomination() { 
      if (this.checkIfEmpty(this.denomination.name)) {
        this.$toast.error("Denomination Name Is Invalid")
        return;
      } 
      if (this.checkIfEmpty(this.applicationType)) {
        this.$toast.error("Application Type Is Invalid")
        return;
      } 
      if (((this.applicationType == "online") || (this.applicationType == "offline" && this.applicationSettlement == "Whish Money")) && this.checkIfEmpty(this.denomination.webServerId)) {
        this.$toast.error("Web Server Is Invalid")
        return;
      } 
      if(this.applicationType == "offline" && this.applicationSettlement == "Whish App"){
        if(this.checkIfEmpty(this.denomination.accountingId)){
          this.$toast.error("Accounting Is Invalid")
          return;
        }
        if(this.checkIfEmpty(this.denomination.commentId)){
          this.$toast.error("Comment Is Invalid")
          return;
        }
      }
      if (this.denomination.newImage && this.checkIfEmpty(this.denomination.imageName) && this.checkIfEmpty(this.denomination.imageData)){
        this.$toast.error("Image Uploaded Is Invalid")
        return;
      }
      if (!this.denomination.newImage && this.checkIfEmpty(this.denomination.imageUrl)){
        this.$toast.error("Image Selected Is Invalid")
        return;
      }
      
      Http()
        .post(ENDPOINTS.createDenomination, {
          applicationType: this.applicationType,
          name: this.denomination.name.toUpperCase(),
          serviceId: this.selectedService,
          imageName: this.denomination.imageName,
          imageUrl: this.denomination.imageUrl,
          imageData: this.denomination.imageData,
          newImage: this.denomination.newImage,
          collectionProviderExist: this.applicationSettlement != "Whish App",
          settlement: this.applicationSettlement,
          webServerId: this.denomination.webServerId,
          bulkMultiBillPayment: this.denomination.bulkMultiBillPayment,
          autoAcceptTopup: this.denomination.autoAcceptTopup,
          commentId: this.denomination.commentId,
          accountingId: this.denomination.accountingId,
          externalId:this.denomination.externalId
        })
        .then((response) => {
          if (response.status) {
            var addedDenomination = {
              id: response.data.denominationId,
              name: response.data.name
            }
            this.denominations.push(addedDenomination)
            this.newDenomination = false
            this.createdDenomination = response.data
            this.denomination.id = response.data.denominationId
            this.$refs.closeDenominationModal.click()
            this.showCreateSchemaPrice = true
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
            if(response.code == "fake.item.error"){
              this.fakeItemFailed = true
              var addedDenomination = {
                id: response.data.denominationId,
                name: response.data.name
              }
              this.showProviderMapping = true
              this.denominations.push(addedDenomination)
              this.newDenomination = false
              this.createdDenomination = response.data
              this.denomination.id = response.data.denominationId
              this.$refs.closeDenominationModal.click()
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    checkUser() {
      var appId = this.selectedApplication != null ? this.selectedApplication.id : this.createdApplication != null ? this.createdApplication.id : null
      Http()
        .post(ENDPOINTS.createAdminUser, {
          applicationId: appId,
          userId:this.adminUser.id
        })
        .then((response) => {
          if (response.status) {
            this.createdAdminUser = response.data
            this.adminUser.password=null;
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    checkDenomination() {
      Http()
        .post(ENDPOINTS.checkDenomination, {
          denominationId: this.denomination.id
        })
        .then((response) => {
          if (response.status) {
            if(this.applicationSettlement == "Whish App"){
              this.showChangeCommentAndAccounting = true
            } else {
              this.getSchemaPrices()
            }
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          this.checkFakeItem();
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    accountSearch() {
      Http()
        .post(ENDPOINTS.getAccount, {
          accountId: this.applicationAccount.id
        })
        .then((response) => {
          if (response.status) {
            this.applicationAccount.name = response.data.name
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    addSchemaPrice(price){
      if (price == null){
        if (this.checkIfEmpty(this.selectedService)){
          this.$toast.error("Please Select A Service")
          return;
        }
        if (!this.fixedSchemaPrice && (this.checkIfEmpty(this.schemaPrice.amountFrom) || this.checkIfEmpty(this.schemaPrice.amountTo))){
          this.$toast.error("Amounts Are Invalid")
          return;
        }
        if (this.checkIfEmpty(this.schemaPrice.priceType)){
          this.$toast.error("Price Type Is Invalid")
          return;
        }
        if (this.checkIfEmpty(this.schemaPrice.currencyId)){
          this.$toast.error("Currency Is Invalid")
          return;
        }
        if (this.checkIfEmpty(this.schemaPrice.discount)){
          this.$toast.error("Discount Is Invalid")
          return;
        }
        if (this.checkIfEmpty(this.schemaPrice.salePrice)){
          this.$toast.error("Sale Price Is Invalid")
          return;
        }
        
        var obj = {}
        obj["amountFrom"] = this.schemaPrice.amountFrom
        obj["amountTo"] = this.schemaPrice.amountTo
        obj["priceType"] = this.schemaPrice.priceType
        obj["currencyId"] = this.schemaPrice.currencyId
        obj["discount"] = this.schemaPrice.discount
        obj["salePrice"] = this.schemaPrice.salePrice
        this.schemaPriceList.push(obj)
        this.schemaPrice.amountFrom = null
        this.schemaPrice.amountTo = null  
        this.schemaPrice.priceType = null
        this.schemaPrice.discount = null
        this.schemaPrice.salePrice = null
      } else {
        var old = this.schemaPriceList.filter(f => f == price)
        if(old[0].amountFrom != null && old[0].amountTo != null){
          this.fixedSchemaPrice = false
        }
        this.schemaPrice.amountFrom = old[0].amountFrom
        this.schemaPrice.amountTo = old[0].amountTo
        this.schemaPrice.priceType = old[0].priceType
        this.schemaPrice.discount = old[0].discount
        this.schemaPrice.salePrice = old[0].salePrice
        const index = this.schemaPriceList.indexOf(old[0]);
        if (index > -1) { 
          this.schemaPriceList.splice(index, 1); 
        }
      }
    },
    createSchemaPrice(){ 
      if(this.fixedSchemaPrice){
        this.schemaPriceList = []
        this.addSchemaPrice()
      }
      if(this.checkIfEmpty(this.schemaPriceList)){
        this.$toast.error("Please Add Schema Prices")
      } else {
        Http()
          .post(ENDPOINTS.createSchemaPrice, {
            fixedPrice: this.fixedSchemaPrice,
            denominationId: this.createdDenomination == null ? this.denomination.id : this.createdDenomination.denominationId,
            serviceId: this.createdService == null ? this.selectedService : this.createdService.serviceId,
            prices: this.schemaPriceList
          })
          .then((response) => {
            if (response.status) {
              this.showCreateSchema = false
              this.createdSchemaPrice = response.data
              this.$refs.closeSchemaPriceModal.click()
              if (this.applicationType == "offline"){
                this.showCreateApplication = true
              } else if (this.applicationType == "online"){
                this.showCreateMenuItem = true
              }
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.success(response.dialog.message)
              }
            } else {
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.error(response.dialog.message)
              }
              if(response.code == "error.schema.price.exists"){
                this.showExistingSchema = true
                this.existingSchemas = response.data
                this.$refs.closeSchemaPriceModal.click()
                if (this.applicationType == "offline"){
                  this.showCreateApplication = true
                } else if (this.applicationType == "online"){
                  this.showCreateMenuItem = true
                }
              }
            }
          })
          .catch((error) => {
            this.$toast.error("Internal Server Error!")
          })
      }       
    },
    createFakeItem(){
      if (this.checkIfEmpty(this.denomination.id)) {
        this.$toast.error("Please Select A Denomination")
      } else {
        Http()
          .post(ENDPOINTS.createFakeItem, {
            denominationId: this.denomination.id,
          })
          .then((response) => {
            if (response.status) {
              this.fakeItemFailed = false
              this.showProviderMapping = true
              this.showCreateSchemaPrice = false
              if (this.applicationSettlement == "Whish App"){
                this.showCreateSchemaPrice = true
              }
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.success(response.dialog.message)
              }
            } else {
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.error(response.dialog.message)
              }
            }
          })
          .catch((error) => {
            this.$toast.error("Internal Server Error!")
          })
      }
    },
    checkFakeItem(){
      Http()
          .post(ENDPOINTS.checkFakeItem, {
            denominationId: this.denomination.id
          })
          .then((response) => {
            if (response.status) {
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.success(response.dialog.message)
              }
            } else {
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.error(response.dialog.message)
              }
              if(response.code == "fake.item.error"){
                this.fakeItemFailed = true
                this.providerMappingFailed=true;
                if (this.applicationType == "offline"){
                  this.showCreateApplication = false
                } else if (this.applicationType == "online"){
                  this.showCreateMenuItem = false
                }
              }
            }
          })
          .catch((error) => {
            this.$toast.error("Internal Server Error!")
          })
    },
    createNewProviderMapping() { 
      
      if (this.checkIfEmpty(this.denomination.externalId) || this.checkIfEmpty(this.providerBillType) && this.applicationType == 'online') {
        this.$toast.error("Please Fill All Required Fields")
      } else {
        Http()
          .post(ENDPOINTS.createProviderDenominaitonMapping, {
            denominationId: this.denomination.id,
            externalDenomination: this.denomination.externalId,
            billType: this.providerBillType,
          })
          .then((response) => {
            if (response.status) {
              this.createdProvider = response.data
              this.newProviderMapping = false
              this.showCreateSchemaPrice = true
              this.$refs.closeMappingModal.click()
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.success(response.dialog.message)
              }
            } else {
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.error(response.dialog.message)
              }
            }
          })
          .catch((error) => {
            this.$toast.error("Internal Server Error!")
          })
      }
    },
    createApplication() { 
      var invalidReference = false
      if(this.applicationIsReference){
        if (this.fields['payerReference'].fieldData.type == "text") {
          if (this.fields['payerReference'].fieldData.inputType == "text") {
            // invalidReference = this.checkIfEmpty(this. fields['payerReference'].fieldData.hint)
          } else if (this.fields['payerReference'].fieldData.inputType == "phone") {
            invalidReference = this.checkIfEmpty(this.fields['payerReference'].fieldData.retrieveSavedContact)
          } else if (this.fields['payerReference'].fieldData.inputType == "numeric" || this.fields['payerReference'].fieldData.inputType == "decimal") {
            invalidReference = this.checkIfEmpty(this. fields['payerReference'].fieldData.hint) || this.checkIfEmpty(this.fields['payerReference'].fieldData.minNumber) || this.checkIfEmpty(this.fields['payerReference'].fieldData.maxNumber) || this.checkIfEmpty(this.fields['payerReference'].fieldData.applicationFieldMinCharacter) || this.checkIfEmpty(this.fields['payerReference'].fieldData.maxChar) || this.checkIfEmpty(this.fields['payerReference'].fieldData.wrongInputHint)
          }
        } else if (this.fields['payerReference'].fieldData.type == "spinner" || this.fields['payerReference'].fieldData.type == "toggle" || this.fields['payerReference'].fieldData.type == "radio" || this.fields['payerReference'].fieldData.type == "checkbox") {
          invalidReference = this.checkIfEmpty(this.fields['payerReference'].fieldData.spinnerObject)
          if (this.fields['payerReference'].fieldData.type == "spinner") {
            invalidReference = this.checkIfEmpty(this.fields['payerReference'].fieldData.spinnerPrompt)
          } else if (this.fields['payerReference'].fieldData.type == "radio") {
            invalidReference = this.checkIfEmpty(this.fields['payerReference'].fieldData.radioSpanCount)
          } else if (this.fields['payerReference'].fieldData.type == "checkbox") {
            invalidReference = this.checkIfEmpty(this.fields['payerReference'].fieldData.checkboxStylePopup)
          }
        }
        if(invalidReference){
          this.$toast.error("Invalid Reference Type");
          return;
        }
      }
      
      for (const [key, field] of Object.entries(this.fields)) {
        if(field != null){
          if(this.applicationSettlement != "Whish Money" && field.id=='reasonId'){
             continue;
          }
          if(!field.newHint&&this.checkIfEmpty(field.hintFromOldKey)){
            if(!this.applicationIsReference && field.identifier == "payerReference"){
              continue     
            }
            this.$toast.error("Field "+field.label+" Has Invalid Value");
            return;
          }
          if(field.newHint&& (this.checkIfEmpty(field.arHint) || this.checkIfEmpty(field.enHint))){
            if(!this.applicationIsReference && field.identifier == "payerReference"){
              continue     
            }
            this.$toast.error("Field "+field.label+" Has Invalid Title");
            return;
          }
        }
      }
      if(!this.applicationIsReference){
        this.fields["payerReference"]=null;
      }
      if(this.applicationSettlement != "Whish Money"){
        this.fields["reasonId"]=null;
      }
      if (this.checkIfEmpty(this.applicationTitle) || this.checkIfEmpty(this.applicationTags)) {
        this.$toast.error("Invalid Application Title Or Tags");
      } else {
        
        Http()
          .post(ENDPOINTS.createApplication, {
            title: this.applicationTitle,
            tags: this.applicationTags.length != 0 ? this.applicationTags.map((m) => m.id) : [],
            settlement: this.applicationSettlement,
            accountId: this.applicationAccount.id,
            denominationId: this.createdDenomination != null ? this.createdDenomination.denominationId : this.denomination.id,
            ...this.fields
          })
          .then((response) => {
            if (response.status) {
              this.createdApplication = response.data
              this.newApplication = false
              this.allowAddApplicationField = true
              this.showCreateMenuItem = true
              this.$refs.closeApplicationModal.click()
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.success(response.dialog.message)
              }
            } else {
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.error(response.dialog.message)
              }
            }
          })
          .catch((error) => {
            this.$toast.error("Internal Server Error!")
          })
      }
    },
    updateApplicationField(field){
      this.editApplicationField = true
      this.applicationField.id = field.id
      var jsonData = JSON.parse(field.data)
      var type = field.type
      this.newApplicationFieldTitle = false
      this.applicationField.hintFromOldKey = field.title
      this.applicationField.fieldData.type = type
      this.applicationField.identifier = field.identifier
      this.applicationField.index = field.index
      this.applicationField.fieldData.dependencies = jsonData.dependencies
      this.applicationField.fieldData.id = field.id

      if(type == "text"){
        this.applicationField.fieldData.hint = jsonData.hint
      } else if (type == "phone"){
        this.applicationField.fieldData.retrieveSavedContact = jsonData.retrieveSavedContact
      } else if (type == "numeric" || type == "decimal"){

        this.applicationField.fieldData.hint = jsonData.hint
        this.applicationField.fieldData.minNumber = jsonData.min
        this.applicationField.fieldData.maxNumber = jsonData.max
        this.applicationField.fieldData.minChar = jsonData.minchar
        this.applicationField.fieldData.maxChar = jsonData.maxchar
        this.applicationField.fieldData.wrongInputHint = jsonData.wrongInputHint
      } else if (type == 'spinner' || type == 'radio' || type == 'toggle' || type == 'checkbox'){
        this.applicationField.fieldData.spinnerPrompt = jsonData.prompt
        this.applicationField.fieldData.applicationFieldTextValueString = jsonData.objects.map(m => JSON.stringify(m))
        this.applicationField.fieldData.spinnerObject = jsonData.objects
        if(type == 'radio'){
          this.applicationField.fieldData.radioSpanCount = jsonData.spanCount
        } else if(type == 'checkbox'){
          this.applicationField.fieldData.radioSpanCount = jsonData.style == "popup"
        }
      } else if (type == 'date' || type == 'datetime'){
        this.applicationField.fieldData.dateFormat = jsonData.format
      }
    },
    createApplicationField() {
      if (this.checkIfEmpty(this.applicationField.fieldData.type)) {
        this.$toast.error("Type Has Invalid Value");
        return;
      }

      if (this.applicationField.newHint && (this.checkIfEmpty(this.applicationField.enHint) || this.checkIfEmpty(this.applicationField.arHint))) {
        this.$toast.error("New Titles Have Invalid Value");
        return;
      }
      
      if (!this.applicationField.newHint && this.checkIfEmpty(this.applicationField.hintFromOldKey)) {
        this.$toast.error("Title Has Invalid Value");
        return;
      }
      
      if (this.checkIfEmpty(this.applicationField.identifier)) {
        this.$toast.error("Identifier Has Invalid Value");
        return;
      }
      
      if (this.checkIfEmpty(this.applicationField.index)) {
        this.$toast.error("Index Has Invalid Value");
        return;
      }
      
      // if (this.applicationField.fieldData.type == "text" && this.checkIfEmpty(this.applicationField.fieldData.hint)) {
      //   this.$toast.error("Hint Has Invalid Value");
      //   return;
      // } 

      if (this.applicationField.fieldData.type == "numeric" || this.applicationField.fieldData.type == "numeric" ) {
          // if (this.checkIfEmpty(this.applicationField.fieldData.hint)) {
          //   this.$toast.error("Hint Has Invalid Value");
          //   return;
          // }
        if (this.checkIfEmpty(this.applicationField.fieldData.minNumber)) {
          this.$toast.error("Min Number Has Invalid Value");
          return;
        }
        if (this.checkIfEmpty(this.applicationField.fieldData.maxNumber)) {
          this.$toast.error("Max Number Has Invalid Value");
          return;
        }
        if (this.checkIfEmpty(this.applicationField.fieldData.minChar)) {
          this.$toast.error("Min Character Has Invalid Value");
          return;
        }
        if (this.checkIfEmpty(this.applicationField.fieldData.maxChar)) {
          this.$toast.error("Max Character Has Invalid Value");
          return;
        }
        if (this.checkIfEmpty(this.applicationField.fieldData.wrongInputHint)) {
          this.$toast.error("Wrong Input Hint Has Invalid Value");
          return;
        }
      } 
       
      if (this.applicationField.fieldData.type == "spinner" || this.applicationField.fieldData.type == "toggle" || this.applicationField.fieldData.type == "radio" || this.applicationField.fieldData.type == "checkbox") {
        if (this.checkIfEmpty(this.applicationField.fieldData.spinnerObject)) {
          this.$toast.error("Text With Values File Has Invalid Value");
          return;
        }
        if (this.applicationField.fieldData == "spinner" && this.checkIfEmpty(this.applicationField.fieldData.spinnerPrompt)) {
          this.$toast.error("Prompt Has Invalid Value");
          return;
        } 
        if (this.applicationField.fieldData == "radio" && this.checkIfEmpty(this.applicationField.fieldData.radioSpanCount)) {
          this.$toast.error("Span Count Prompt Has Invalid Value");
          return;
        } 
      }

      if (this.createdApplication == null && this.selectedApplication == null) {
        this.$toast.error("Cannot Add Fields")
        return;
      } else {
        var appId = this.selectedApplication != null ? this.selectedApplication.id : this.createdApplication != null ? this.createdApplication.id : null
        Http()
          .post(ENDPOINTS.createApplicationField, {
            edit: this.editApplicationField,
            fieldId: this.applicationField.id,
            applicationId: appId,
            ...this.applicationField
          })
          .then((response) => {
            if (response.status) {
              this.getApplicationFieldsByApplicationId() 
              this.createdApplicationField = response.data
              this.newApplicationField = false
              this.showCreateMenuItem = true
              this.$refs.closeApplicationFieldModal.click()
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.success(response.dialog.message)
              }
            } else {
              if (response.dialog != null && response.dialog.message != null) {
                this.$toast.error(response.dialog.message)
              }
            }
          })
          .catch((error) => {
            this.$toast.error("Internal Server Error!")
          })
      }
    },
    createMenuItem() {
      if (!this.importedMenuItem) {
        if (this.checkIfEmpty(this.menuItem.menuId)){
          this.$toast.error("Menu ID Has Invalid Value");
          return;
        }
        if(this.menuItem.localize){
          if (this.menuItem.newHint && (this.checkIfEmpty(this.menuItem.enHint) || this.checkIfEmpty(this.menuItem.arHint))) {
            this.$toast.error("New Titles Have Invalid Value");
            return;
          }
          if (!this.menuItem.newHint && this.checkIfEmpty(this.menuItem.hintFromOldKey)) {
            this.$toast.error("Title Has Invalid Value");
            return;
          } 
        } else if (this.checkIfEmpty(this.menuItem.hintFromOldKey)) {
            this.$toast.error("Label Has Invalid Value");
            return;
        } 
        if (this.menuItem.newImage && this.checkIfEmpty(this.menuItem.imageName) && this.checkIfEmpty(this.menuItem.imageData)){
          this.$toast.error("Image Upload Is Invalid");
          return;
        }
        if (!this.menuItem.newImage && this.checkIfEmpty(this.menuItem.imageUrl)){
          this.$toast.error("Image Selected Has Invalid Value");
          return;
        }
      }
      if (this.applicationType == 'online') {
        if(this.checkIfEmpty(this.menuItem.dataRequest.type)){
          this.$toast.error("Input Type Has Invalid Value");
          return;
        }
        if (this.menuItem.dataRequest.type == "text" && this.checkIfEmpty(this.menuItem.dataRequest.hint)) {
          this.$toast.error("Hint Has Invalid Value");
          return;
        } 
        if (this.menuItem.dataRequest.type == "numeric" || this.menuItem.dataRequest.type == "numeric" ) {
          if (this.checkIfEmpty(this.menuItem.dataRequest.hint)) {
            this.$toast.error("Hint Has Invalid Value");
            return;
          }
          if (this.checkIfEmpty(this.menuItem.dataRequest.minNumber)) {
            this.$toast.error("Min Number Has Invalid Value");
            return;
          }
          if (this.checkIfEmpty(this.menuItem.dataRequest.maxNumber)) {
            this.$toast.error("Max Number Has Invalid Value");
            return;
          }
          if (this.checkIfEmpty(this.menuItem.dataRequest.minChar)) {
            this.$toast.error("Min Character Has Invalid Value");
            return;
          }
          if (this.checkIfEmpty(this.menuItem.dataRequest.maxChar)) {
            this.$toast.error("Max Character Has Invalid Value");
            return;
          }
          if (this.checkIfEmpty(this.menuItem.dataRequest.wrongInputHint)) {
            this.$toast.error("Wrong Input Hint Has Invalid Value");
            return;
          }
        } 
        if(this.importedMenuItem && this.checkIfEmpty(this.selectedMenuItem.data)){
          this.$toast.error("Imported Menu Item Has Error In Its Data, Please Contact The Team");
          return;
        }
      }
     
      var appId = this.selectedApplication != null ? this.selectedApplication.id : this.createdApplication != null ? this.createdApplication.id : null
      Http()
        .post(ENDPOINTS.createMenuItem, {
          newMenuItem: !this.importedMenuItem,
          id: this.importedMenuItem ? this.selectedMenuItem.id : null,
          serviceId: this.applicationType == 'online' ? this.selectedService : null,
          denominationId: this.applicationType == 'online' ? this.denomination.id : null,
          applicationId: this.applicationType == 'offline' ? appId : null,
          data: this.importedMenuItem ? this.selectedMenuItem.data : null,
          ...this.menuItem
        })
        .then((response) => { 
          if (response.status) {
            this.createdMenuItem = response.data
            this.newMenuItem = false
            this.showCreateAdminUser = true
            this.$refs.closeMenuitemModal.click()
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    createAdminUser() {
      if (this.checkIfEmpty(this.adminUser.name)) {
        this.$toast.error("Name Has Invalid Value");
        return;
      }
      if (this.checkIfEmpty(this.adminUser.userName)) {
        this.$toast.error("UserName Has Invalid Value");
        return;
      }
      if (this.checkIfEmpty(this.adminUser.password)) {
        this.$toast.error("Password Has Invalid Value");
        return;
      }
      var appId = this.selectedApplication != null ? this.selectedApplication.id : this.createdApplication != null ? this.createdApplication.id : null
      this.adminUser.userName = this.adminUser.userName.toLowerCase()
      this.adminUser.name = this.adminUser.name.toUpperCase()
      Http()
        .post(ENDPOINTS.createAdminUser, {
          applicationId: appId,
          ...this.adminUser
        })
        .then((response) => {
          if (response.status) {
            this.createdAdminUser = response.data
            this.$refs.closeAdminUserModal.click()
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.success(response.dialog.message)
            }
          } else {
            if (response.dialog != null && response.dialog.message != null) {
              this.$toast.error(response.dialog.message)
            }
          }
        })
        .catch((error) => {
          this.$toast.error("Internal Server Error!")
        })
    },
    onJSONFileChange(e) {
      var reader = new FileReader();
      reader.onload = (res) => {
        var result = res.target.result;
        var lines = result.split('\n');
        var listOfObj = []
        for (var i = 0; i < lines.length; i++) {
          var line = lines[i].slice(0, -1).split(/\s?,\s?/).map(item => item.split(':')).reduce((a, [key, val]) => Object.assign(a, { [key]: val }), {});
          listOfObj.push(line)
        }
        this.applicationFieldData.spinnerObject = listOfObj;
        this.applicationFieldData.applicationFieldTextValueString = result
      };
      reader.readAsText(e.target.files[0]);
    },
    checkIfEmpty(value) {
      return value === null || value === ''
    },
    reloadPage() {
      window.location.reload();
    },
    refreshDocuments(isMenu){
      if(isMenu){
        this.getMenuDocumnets("created", true)
      } else {
        this.getDenominationDocumnets("created", true)
      }
    },
  }
};
</script>

<style scoped>
.title {
  font-size: 30px;
  font-weight: bold;
}

.subTitle{
  font-size: 23px;
  font-weight: 500;
}

.btn-primary{
  background-color: #E40046!important;
}

input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button {  

   opacity: 1;

}

table, tr, th, td{
  border: 1px solid black;
  padding: 5px
}
</style>
